export const SUCCESS_MSG = (type) => {
    return `Your request for ${type} action is successfuly submitted`;
};
export const ERROR_MSG = "There is some techincal error. Please try again";

export const CART_STATUS = {
    New: 1,
    Draft: 2,
    CheckedOut: 3,
    Pending: 4,
    PaymentCompleted: 5,
    Submitted: 6,
    Cancelled: 13,
};

export const STRUCTURE_TYPE = {
    SF: {
        imgsrc: "single.svg",
        label: "Single family",
    },
    MF: {
        imgsrc: "multi.svg",
        label: "Multi-family",
    },
    COM: {
        imgsrc: "commercial.svg",
        label: "Commercial",
    },
    CON: {
        imgsrc: "condo.svg",
        label: "Condo/HOA",
    },
};

export const ACTION_DESCRIPTION = {
    EDIT: `Editing a warranty will remove it from your cart. Once you are finished editing, you can add the warranty back to your cart.`,
    COPY: `Would you like to create a new warranty with the same details as this warranty?`,
    REMOVE: `Would you like to remove this warranty from your cart and send it back to your drafts?`,
    DELETE: `By doing so, you will reverse the payment and the contractor will be credited the full amount of the cart.`
};

export const SUCCESS_STATUS = {
    ADD: "has been added to your cart.",
    DELETE: "has been removed from your cart and placed in your Drafts.",
};
